import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import store from 'src/services/store';
import JssProvider from 'src/jssProvider'; // important for correct styles order
import theme from 'src/theme';
import Login from 'src/containers/login';

const AppLogin = () => (
  <ReduxProvider store={store}>
    <JssProvider>
      <ThemeProvider theme={theme}>
        <Login />
      </ThemeProvider>
    </JssProvider>
  </ReduxProvider>
);

export default AppLogin;
